import React, { useEffect, useRef, useState } from 'react';

const ATTENTION_WINDOW_MS = 1400;

const CountBadge = ({ count, style = {} }) => {
  const [isAnimating, setIsAnimating] = useState(Boolean(count && count > 0));
  const previousCountRef = useRef(count || 0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const previousCount = previousCountRef.current || 0;
    const nextCount = count || 0;
    const shouldAnimate = nextCount > 0 && nextCount > previousCount;

    if (shouldAnimate) {
      setIsAnimating(true);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setIsAnimating(false);
      }, ATTENTION_WINDOW_MS);
    }

    previousCountRef.current = nextCount;

    return undefined;
  }, [count]);

  useEffect(() => () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);

  if (!count || count < 1) return null;

  return (
    <>
      <style>
        {`
          @keyframes countBadgePopIn {
            0% { transform: scale(0.7); opacity: 0; }
            45% { transform: scale(1.18); opacity: 1; }
            70% { transform: scale(0.96); }
            100% { transform: scale(1); opacity: 1; }
          }

          @keyframes countBadgeGlowPulse {
            0%, 100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.18); }
            50% { box-shadow: 0 0 0 8px rgba(239, 68, 68, 0); }
          }
        `}
      </style>
      <span
        style={{
          backgroundColor: '#ef4444',
          color: 'white',
          fontSize: '10px',
          padding: '2px 6px',
          borderRadius: '10px',
          fontWeight: 'bold',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: '20px',
          transformOrigin: 'center',
          animation: isAnimating
            ? 'countBadgePopIn 260ms ease-out, countBadgeGlowPulse 1.1s ease-out 2'
            : 'none',
          ...style
        }}
      >
        {count}
      </span>
    </>
  );
};

export default CountBadge;
